
import classes from './Button.module.css'
import LoadingSpinnerButton from '../../LoadingSpinners/LoadingSpinnerButton'
import { forwardRef } from 'react'


const Button = forwardRef((props, ref) => {
    return (
        <button 
            ref={ref}
            className={`${classes['btn']} ${props.delete && classes.delete} ${props.className}`} 
            type={props.type ? props.type : 'button'} 
            onClick={(e) => {!props.loading && props.onClick && props.onClick(e)}} 
            disabled={props.disabled}
            data-testid={props['data-testid']}>
            {props.children}
            {props.loading && <LoadingSpinnerButton/>}
        </button>
    )
})

export default Button